import { useQuery } from '@tanstack/react-query';
import { getConversationTasks } from '@terminal/views/alfred/research/services/conversations-service';

export const QUERY_KEY_CONVERSATION_TASK = 'QUERY_KEY_CONVERSATION_TASK';

export const useConversationTask = (
  conversationId: string,
  enabled: boolean = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_CONVERSATION_TASK, conversationId],
    queryFn: async ({ signal }) => {
      const result = await getConversationTasks(conversationId, signal);
      return result.data;
    },
    enabled,
  });
